<template>
  <AdminLayout>
    <Head title="Edit Product" />

    <template #pageAlerts>
      <SuccessFlash :flash="flash"></SuccessFlash>
      <ErrorFlash
        v-if="flash.error"
        :message="flash.error"
      ></ErrorFlash>
      <ErrorFlash
        v-if="hasErrors(form)"
        :message="'An error has occurred'"
      ></ErrorFlash>
      <ErrorFlash
        v-if="getErrors('media', form)"
        :message="getErrors('media', form)"
      ></ErrorFlash>
    </template>

    <div class="headline flex flex-col-reverse md:flex-row justify-between items-start md:items-center mx-4 sm:mx-12">
      <h2
        class="text-xl sm:text-2xl font-semibold pb-5 pt-5 text-blue-600 flex flex-col md:flex-row items-start md:items-end"
      >
        <span class="flex flex-col -mt-5">
          <span class="page-type text-sm sm:text-base">Product</span>
          {{ product.name }}
        </span>
      </h2>

      <div class="relative inline-flex shadow-sm rounded-md md:items-start items-end self-end md:self-auto mt-2">
        <BasicButton
          @click="save()"
          type="button"
          button-style="primary"
          class="mr-4 py-3"
        >
          Save Changes
        </BasicButton>

        <Menu
          as="div"
          class="relative inline-block text-left"
        >
          <div>
            <MenuButton
              class="inline-flex justify-center w-full rounded-md border border-gray-400 shadow-sm px-4 py-3 bg-gray-100 text-sm font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-400 focus:ring-indigo-500"
            >
              Actions
              <ChevronDownIcon
                class="-mr-1 ml-2 h-5 w-5"
                aria-hidden="true"
              />
            </MenuButton>
          </div>

          <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="opacity-0 scale-95"
            enter-to-class="opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-95"
          >
            <MenuItems
              class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-gray-100 ring-1 ring-gray-400 ring-opacity-5 divide-y divide-gray-400 focus:outline-none z-50"
            >
              <div class="py-1">
                <!-- <MenuItem v-slot="{ active }">
                                <a @click.prevent="printLabel()" href="#" :class="['text-gray-700 hover:text-gray-200 hover:bg-blue-600 group flex items-center px-4 py-2 text-sm']">
                                    <QrcodeIcon class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-200" aria-hidden="true" />
                                    Print Label
                                </a>
                            </MenuItem> -->
                <!-- <MenuItem v-slot="{ active }">
                                <a @click.prevent="showDispense()" href="#" :class="['text-gray-700 hover:text-gray-200 hover:bg-blue-600 group flex items-center px-4 py-2 text-sm']">
                                    <ArrowCircleRightIcon class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-200" aria-hidden="true" />
                                    Dispense
                                </a>
                            </MenuItem> -->
                <MenuItem
                  v-slot="{ active }"
                  v-if="showGenerateSkuAction"
                >
                  <a
                    @click.prevent="generateSku()"
                    href="#"
                    :class="[
                      'text-gray-700 hover:text-gray-200 hover:bg-blue-600 group flex items-center px-4 py-2 text-sm'
                    ]"
                  >
                    <DuplicateIcon
                      class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-200"
                      aria-hidden="true"
                    />
                    Generate SKU
                  </a>
                </MenuItem>
                <MenuItem v-slot="{ active }">
                  <a
                    @click.prevent="showDuplicate()"
                    href="#"
                    :class="[
                      'text-gray-700 hover:text-gray-200 hover:bg-blue-600 group flex items-center px-4 py-2 text-sm'
                    ]"
                  >
                    <DuplicateIcon
                      class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-200"
                      aria-hidden="true"
                    />
                    Duplicate
                  </a>
                </MenuItem>
                <MenuItem v-slot="{ active }">
                  <a
                    @click.prevent="goToCreatePackage()"
                    href="#"
                    :class="[
                      'text-gray-700 hover:text-gray-200 hover:bg-blue-600 group flex items-center px-4 py-2 text-sm'
                    ]"
                  >
                    <CollectionIcon
                      class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-200"
                      aria-hidden="true"
                    />
                    Create Package
                  </a>
                </MenuItem>
                <MenuItem v-slot="{ active }">
                  <a
                    @click.prevent="goToAudit()"
                    href="#"
                    :class="[
                      'text-gray-700 hover:text-gray-200 hover:bg-blue-600 group flex items-center px-4 py-2 text-sm'
                    ]"
                  >
                    <SearchIcon
                      class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-200"
                      aria-hidden="true"
                    />
                    Audit
                  </a>
                </MenuItem>
              </div>
              <div class="py-1">
                <MenuItem v-slot="{ active }">
                  <a
                    v-if="product.deleted_at"
                    @click.prevent="restore()"
                    href="#"
                    :class="[
                      'text-gray-700 hover:text-gray-200 hover:bg-blue-600 group flex items-center px-4 py-2 text-sm'
                    ]"
                  >
                    <ArchiveIcon
                      class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-200"
                      aria-hidden="true"
                    />
                    Restore
                  </a>
                  <a
                    v-else
                    @click.prevent="archive()"
                    href="#"
                    :class="[
                      'text-gray-700 hover:text-gray-200 hover:bg-blue-600 group flex items-center px-4 py-2 text-sm'
                    ]"
                  >
                    <ArchiveIcon
                      class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-200"
                      aria-hidden="true"
                    />
                    Archive
                  </a>
                </MenuItem>
              </div>
              <div
                class="py-1"
                v-if="isAdmin && novaRoute"
              >
                <MenuItem v-slot="{ active }">
                  <NovaMenuButton :nova-route="novaRoute" />
                </MenuItem>
              </div>
            </MenuItems>
          </transition>
        </Menu>
      </div>
    </div>

    <div
      class="tabs flex-1 flex flex-col"
      :class="{
        'overflow-hidden': pageLayout.shouldLock.value
      }"
    >
      <PageTabGroup>
        <PageTabList>
          <PageTab label="Details" />
          <PageTab label="Media" />
          <PageTab label="Pricing" />
          <PageTab label="Inventory" />
          <PageTab
            v-if="hasPermission('view_activity')"
            label="Activity Log"
          />
        </PageTabList>

        <PageTabPanels>
          <PageTabPanel>
            <div class="sm:flex sm:justify-between sm:border-b sm:border-gray-400 sm:pb-5 mb-5">
              <div class="border-b border-gray-400 sm:border-b-0 pb-5 sm:pb-0">
                <h3 class="text-lg leading-6 font-semibold text-blue-600">Product Details</h3>
                <p class="mt-1 max-w-2xl text-sm text-gray-600">
                  This information defines product level detail on the point-of-sale and eCommerce website.
                </p>
              </div>
              <div class="input-group pt-5 sm:pt-0">
                <label for="product_sku"> E-commerce </label>
                <div class="input-group-checkbox items-center py-3">
                  <div class="input-checkbox-container">
                    <input
                      v-model="form.has_ecommerce"
                      id="has_ecommerce"
                      name="has_ecommerce"
                      type="checkbox"
                    />
                  </div>
                  <div class="input-label-container">
                    <label for="has_ecommerce"> Available for purchase? </label>
                    <!--<p class="text-gray-600">Product is for sale online.</p>-->
                  </div>
                </div>
                <p
                  v-if="getErrors('has_ecommerce', form)"
                  class="input-error"
                >
                  {{ getErrors('has_ecommerce', form) }}
                </p>
              </div>
            </div>

            <div class="grid grid-cols-12 gap-6 sm:mb-4 items-stretch">
              <div class="input-group col-span-12 sm:col-span-3">
                <label for="product_name"> Product Name </label>
                <input
                  v-model="form.name"
                  type="text"
                  id="product_name"
                />
                <p
                  v-if="getErrors('name', form)"
                  class="input-error"
                >
                  {{ getErrors('name', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-3">
                <label for="product_sku"> SKU </label>
                <input
                  v-model="form.sku"
                  disabled
                  type="text"
                  id="product_sku"
                />
                <p
                  v-if="getErrors('sku', form)"
                  class="input-error"
                >
                  {{ getErrors('sku', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-3">
                <label for="alias_name"> Alias Name </label>
                <input
                  v-model="form.alias_name"
                  type="text"
                  id="alias_name"
                />
                <p
                  v-if="getErrors('alias_name', form)"
                  class="input-error"
                >
                  {{ getErrors('alias_name', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-3">
                <label for="published"> Published? </label>
                <select
                  v-model="form.is_published"
                  id="published"
                >
                  <option :value="true">Published</option>
                  <option :value="false">Draft</option>
                </select>
                <p
                  v-if="getErrors('is_published', form)"
                  class="input-error"
                >
                  {{ getErrors('is_published', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-3">
                <label for="item_number"> Item # </label>
                <input
                  v-model="form.item_number"
                  type="text"
                  id="item_number"
                />
                <p
                  v-if="getErrors('item_number', form)"
                  class="input-error"
                >
                  {{ getErrors('item_number', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-3">
                <label for="product_type"> Type </label>
                <select
                  v-model="form.type"
                  id="product_type"
                >
                  <option :value="null">Select Type</option>
                  <option
                    v-for="(type, index) in types"
                    :key="index"
                    :value="index"
                  >
                    {{ type }}
                  </option>
                </select>
                <p
                  v-if="getErrors('type', form)"
                  class="input-error"
                >
                  {{ getErrors('type', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-3">
                <label for="product_regulated"> Regulated </label>
                <select
                  v-model="form.regulation_type"
                  id="product_regulated"
                >
                  <option :value="null">Select Regulation</option>
                  <option
                    v-for="(type, key) in regulationTypes"
                    :key="key"
                    :value="key"
                  >
                    {{ type }}
                  </option>
                </select>
                <p
                  v-if="getErrors('regulation_type', form)"
                  class="input-error"
                >
                  {{ getErrors('regulation_type', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-3">
                <label for="product_is_external"> Internal/External </label>
                <select
                  v-model="form.is_external"
                  id="product_is_external"
                >
                  <option :value="false">Internal</option>
                  <option :value="true">External</option>
                </select>
                <p
                  v-if="getErrors('is_external', form)"
                  class="input-error"
                >
                  {{ getErrors('is_external', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-4">
                <label for="total_qty"> Total Qty </label>
                <div class="mt-1 relative sub-group rounded-md shadow-sm border-gray-400 border">
                  <input
                    v-model="form.quantity_total"
                    disabled
                    class="input-text"
                    type="text"
                    id="total_qty"
                  />
                  <div class="absolute inset-y-0 right-0 flex items-center">
                    <label
                      for="total_uom"
                      class="sr-only"
                      >UoM</label
                    >
                    <select
                      v-model="form.unit"
                      id="total_uom"
                      class="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-600 sm:text-sm rounded-md"
                    >
                      <option
                        v-for="(unit, key) in units"
                        :key="key"
                        :value="key"
                      >
                        {{ unit }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="input-group col-span-12 sm:col-span-4">
                <label for="available_qty"> Remaining Qty </label>
                <div class="mt-1 relative rounded-md shadow-sm border-gray-400 border">
                  <input
                    v-model="form.quantity_available"
                    disabled
                    class="input-text"
                    type="text"
                    id="available_qty"
                  />
                  <div class="absolute inset-y-0 right-0 flex items-center">
                    <label
                      for="available_uom"
                      class="sr-only"
                    >
                      UoM
                    </label>
                    <select
                      v-model="form.unit"
                      id="available_uom"
                      class="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-600 sm:text-sm rounded-md"
                    >
                      <option
                        v-for="(unit, key) in units"
                        :key="key"
                        :value="key"
                      >
                        {{ unit }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="input-group col-span-12 sm:col-span-4">
                <label for="concentration"> Unit Weight </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <input
                    v-model="form.unit_weight"
                    type="number"
                    step="0.01"
                    id="unit_weight"
                  />
                  <div class="absolute inset-y-0 right-0 flex items-center">
                    <label
                      for="unit_weight"
                      class="sr-only"
                    >
                      Weight
                    </label>
                    <select
                      v-model="form.unit"
                      id="unit"
                      class="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-600 sm:text-sm rounded-md"
                    >
                      <option
                        v-for="(unit, key) in units"
                        :key="key"
                        :value="key"
                      >
                        {{ unit }}
                      </option>
                    </select>
                  </div>
                </div>
                <p
                  v-if="getErrors('unit_weight', form)"
                  class="input-error"
                >
                  {{ getErrors('unit_weight', form) }}
                </p>
                <p
                  v-if="getErrors('unit', form)"
                  class="input-error"
                >
                  {{ getErrors('unit', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-4">
                <label for="product-strain"> Strain </label>
                <div class="input-append">
                  <ComboBox
                    :data="strains"
                    :filter-on="'name'"
                    :label="
                      (strain) =>
                        strain ? `${strain.name}` + (strain.lineage ? ` (${strain.lineage})` : '') : 'Select a Strain'
                    "
                    :current-selection="
                      product.strain ? strains.find((strain) => strain.id === product.strain.id) : null
                    "
                    @update="(strain) => (form.strain_id = strain.id)"
                  />
                  <button
                    @click="openAddStrain()"
                    type="button"
                    class="input-addon"
                  >
                    <span>+</span>
                  </button>
                </div>

                <p
                  v-if="getErrors('strain_id', form)"
                  class="input-error"
                >
                  {{ getErrors('strain_id', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-4">
                <label for="product-supplier"> Supplier </label>
                <div class="input-append">
                  <div class="input-control">
                    <ComboBox
                      :data="suppliers"
                      :filter-on="'name'"
                      :label="(supplier) => (supplier ? `${supplier.name}` : 'Select Supplier')"
                      :current-selection="
                        product.supplier ? suppliers.find((supplier) => supplier.id === product.supplier.id) : null
                      "
                      @update="(supplier) => (form.supplier_id = supplier.id)"
                    />
                  </div>
                  <button
                    @click="openAddSupplier()"
                    type="button"
                    class="input-addon"
                  >
                    <span>+</span>
                  </button>
                </div>
                <p
                  v-if="getErrors('supplier_id', form)"
                  class="input-error"
                >
                  {{ getErrors('supplier_id', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-4">
                <label for="product-supplier"> Brand </label>
                <div class="input-append">
                  <div class="input-control">
                    <ComboBox
                      :data="brands"
                      :filter-on="'name'"
                      :label="(brand) => (brand ? `${brand.name}` : 'Select Brand')"
                      :current-selection="product.brand ? brands.find((brand) => brand.id === product.brand.id) : null"
                      @update="(brand) => (form.brand_id = brand.id)"
                    />
                  </div>
                  <button
                    @click="openAddBrand()"
                    type="button"
                    class="input-addon"
                  >
                    <span>+</span>
                  </button>
                </div>
                <p
                  v-if="getErrors('brand_id', form)"
                  class="input-error"
                >
                  {{ getErrors('brand_id', form) }}
                </p>
              </div>
              <!--                                    <div class="input-group col-span-12 sm:col-span-3">-->
              <!--                                        <div class="input-append mt-0">-->
              <!--                                            <div class="input-control">-->
              <!--                                                <MultiSelectInput v-model="form.category_id" :options="categoryOptions" placeholder="Select Categories">-->
              <!--                                                    Categories-->
              <!--                                                    <template v-slot:append class="input-append">-->
              <!--                                                        <button @click="showingAddCategory = true" type="button" class="input-addon">-->
              <!--                                                            <span>+</span>-->
              <!--                                                        </button>-->
              <!--                                                    </template>-->
              <!--                                                </MultiSelectInput>-->
              <!--                                            </div>-->
              <!--                                        </div>-->
              <!--                                        <p v-if="getErrors('categories', form)" class="input-error">-->
              <!--                                            {{ getErrors('categories', form) }}-->
              <!--                                        </p>-->
              <!--                                    </div>-->
              <div class="input-group col-span-12 sm:col-span-4">
                <label for="product-category"> Category </label>
                <select
                  v-model="form.category_id"
                  id="product-category"
                >
                  <option :value="null">Select Category</option>
                  <option
                    v-for="category in categories"
                    :key="category.id"
                    :value="category.id"
                  >
                    {{ category.name }}
                  </option>
                </select>
                <p
                  v-if="getErrors('category_id', form)"
                  class="input-error"
                >
                  {{ getErrors('category_id', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-4">
                <label for="product-sub-category"> Sub-Category </label>
                <select
                  v-model="form.sub_category_id"
                  id="product-sub-category"
                >
                  <option :value="null">Select Sub-Category</option>
                  <option
                    v-for="subCategory in subCategories"
                    :key="subCategory.id"
                    :value="subCategory.id"
                  >
                    {{ subCategory.name }}
                  </option>
                </select>
                <p
                  v-if="getErrors('sub_category_id', form)"
                  class="input-error"
                >
                  {{ getErrors('sub_category_id', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-4">
                <div class="input-append mt-0">
                  <div class="input-control">
                    <MultiSelectInput
                      v-model="form.product_tags"
                      :options="productTagOptions"
                      placeholder="Select Tags"
                    >
                      Tags
                      <template
                        v-slot:append
                        class="input-append"
                      >
                        <button
                          @click="showingAddTag = true"
                          type="button"
                          class="input-addon"
                        >
                          <span>+</span>
                        </button>
                      </template>
                    </MultiSelectInput>
                  </div>
                </div>
                <p
                  v-if="getErrors('product_tags', form)"
                  class="input-error"
                >
                  {{ getErrors('product_tags', form) }}
                </p>
              </div>
              <div
                v-if="showMedicalRouteId"
                class="input-group col-span-12 sm:col-span-4"
              >
                <label for="product-route"> Medical Route </label>
                <select
                  v-model="form.medical_route_id"
                  id="product-route"
                  :disabled="!hasPermission('update_routes_for_products')"
                >
                  <option :value="null">Select Route</option>
                  <option
                    v-for="type in medicalRoutes"
                    :key="type.id"
                    :value="type.id"
                  >
                    {{ type.name }}
                  </option>
                </select>
                <p
                  v-if="getErrors('medical_route_id', form)"
                  class="input-error"
                >
                  {{ getErrors('medical_route_id', form) }}
                </p>
              </div>
              <div
                v-if="showMedicalDeviceId"
                class="input-group col-span-12 sm:col-span-4"
              >
                <label for="product-route"> Medical Device </label>
                <select
                  v-model="form.medical_device_id"
                  id="product-device"
                >
                  <option :value="null">Select Device</option>
                  <option
                    v-for="type in medicalDevices"
                    :key="type.id"
                    :value="type.id"
                  >
                    {{ type.name }}
                  </option>
                </select>
                <p
                  v-if="getErrors('medical_device_id', form)"
                  class="input-error"
                >
                  {{ getErrors('medical_device_id', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-12">
                <fieldset>
                  <div class="flex">
                    <div class="flex items-center">
                      <input
                        v-model="form.is_recreational"
                        :value="false"
                        name="is_recreational"
                        type="radio"
                        class="focus:ring-blue-600 h-5 w-5 text-blue-600 border-gray-400"
                      />
                      <label
                        for="is_recreational"
                        class="block font-medium text-gray-700 px-3"
                      >
                        Medical
                      </label>
                    </div>
                    <div class="flex items-center">
                      <input
                        v-model="form.is_recreational"
                        :value="true"
                        name="is_recreational"
                        type="radio"
                        class="focus:ring-blue-600 h-5 w-5 text-blue-600 border-gray-400"
                      />
                      <label
                        for="is_recreational"
                        class="block font-medium text-gray-700 px-3"
                      >
                        Recreational
                      </label>
                    </div>
                  </div>
                  <p
                    v-if="getErrors('is_recreational')"
                    class="mt-2 text-sm text-red-600"
                  >
                    {{ getErrors('is_recreational') }}
                  </p>
                </fieldset>
              </div>
              <div class="input-group col-span-12 sm:col-span-12 mt-4">
                <label for="product-excerpt"> Excerpt </label>
                <textarea
                  v-model="form.excerpt"
                  rows="5"
                  type="text"
                  id="product-excerpt"
                  autocomplete="product-excerpt"
                  class="text-sm"
                />
                <p
                  v-if="getErrors('excerpt', form)"
                  class="input-error"
                >
                  {{ getErrors('excerpt', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-12">
                <label for="product-description"> Description </label>
                <textarea
                  class="text-sm"
                  v-model="form.description"
                  rows="5"
                  type="text"
                  id="product-description"
                  autocomplete="product-description"
                />
                <p
                  v-if="getErrors('description', form)"
                  class="input-error"
                >
                  {{ getErrors('description', form) }}
                </p>
              </div>
            </div>
          </PageTabPanel>

          <PageTabPanel>
            <media-manager
              :files="media"
              :upload="uploadRoute"
              :featured="featuredRoute"
              :destroy="deleteRoute"
              :vapor="vapor"
              collection-name="media"
              upload-key="media"
            />

            <!--                                <media-uploader :files="media"-->
            <!--                                                :src="uploadRoute"-->
            <!--                                                collection-name="media"-->
            <!--                                                upload-key="media"-->
            <!--                                >-->

            <!--                                </media-uploader>-->
          </PageTabPanel>

          <PageTabPanel>
            <div class="sm:border-b sm:border-gray-400 sm:pb-5 mb-5">
              <h3 class="text-lg leading-6 font-semibold text-blue-600">Price Options</h3>
              <p class="mt-1 max-w-2xl text-sm text-gray-600">
                Create a single price or create tiered pricing whatever suits you.
              </p>
            </div>

            <div class="grid grid-cols-12 gap-6 sm:mb-5">
              <div class="input-group col-span-12 sm:col-span-3">
                <label for="sale_price"> Sale Price </label>
                <div class="relative">
                  <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <span class="text-gray-600 sm:text-sm"> $ </span>
                  </div>
                  <input
                    v-model="form.sale_price"
                    type="text"
                    class="pl-7 mt-1"
                    id="sale_price"
                  />
                  <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <span class="text-gray-600 sm:text-sm"> USD </span>
                  </div>
                </div>
                <p
                  v-if="getErrors('sale_price', form)"
                  class="input-error"
                >
                  {{ getErrors('sale_price', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-3">
                <label for="unit_price"> Unit Price </label>
                <div class="relative">
                  <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <span class="text-gray-600 sm:text-sm"> $ </span>
                  </div>
                  <input
                    v-model="form.unit_price"
                    type="text"
                    class="pl-7 mt-1"
                    id="unit_price"
                  />
                  <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <span class="text-gray-600 sm:text-sm"> USD </span>
                  </div>
                </div>
                <p
                  v-if="getErrors('unit_price', form)"
                  class="input-error"
                >
                  {{ getErrors('unit_price', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-3">
                <label for="unit_cost"> Unit Cost </label>
                <div class="relative">
                  <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <span class="text-gray-600 sm:text-sm"> $ </span>
                  </div>
                  <input
                    v-model="form.unit_cost"
                    type="text"
                    class="pl-7 mt-1"
                    id="unit_cost"
                  />
                  <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <span class="text-gray-600 sm:text-sm"> USD </span>
                  </div>
                </div>
                <p
                  v-if="getErrors('unit_cost', form)"
                  class="input-error"
                >
                  {{ getErrors('unit_cost', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-3">
                <label for="price_per_unit"> Price per Unit </label>
                <div class="relative">
                  <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <span class="text-gray-600 sm:text-sm"> $ </span>
                  </div>
                  <input
                    v-model="form.price_per_unit"
                    disabled
                    type="text"
                    class="pl-7 mt-1"
                    id="price_per_unit"
                  />
                  <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <span class="text-gray-600 sm:text-sm"> g </span>
                  </div>
                </div>
              </div>
              <div class="input-group col-span-12 sm:col-span-3">
                <label for="concentration"> Concentration </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <input
                    v-model="form.pricing_concentration"
                    type="text"
                    id="concentration"
                  />
                  <div class="absolute inset-y-0 right-0 flex items-center">
                    <label
                      for="available_uom"
                      class="sr-only"
                    >
                      UoM
                    </label>
                    <select
                      v-model="form.pricing_unit"
                      id="available_uom"
                      class="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-600 sm:text-sm rounded-md"
                    >
                      <option
                        v-for="(unit, key) in units"
                        :key="key"
                        :value="key"
                      >
                        {{ unit }}
                      </option>
                    </select>
                  </div>
                </div>
                <p
                  v-if="getErrors('pricing_concentration', form)"
                  class="input-error"
                >
                  {{ getErrors('pricing_concentration', form) }}
                </p>
                <p
                  v-if="getErrors('pricing_unit', form)"
                  class="input-error"
                >
                  {{ getErrors('pricing_unit', form) }}
                </p>
              </div>
              <div class="input-group col-span-12 sm:col-span-3">
                <label for="product_sku"> Discounts </label>
                <div class="input-group-checkbox items-center py-3">
                  <div class="input-checkbox-container">
                    <input
                      v-model="form.is_discountable"
                      id="is_discountable"
                      name="is_discountable"
                      type="checkbox"
                    />
                  </div>
                  <div class="input-label-container">
                    <label for="is_discountable"> Can be applied </label>
                  </div>
                </div>
                <p
                  v-if="getErrors('is_discountable', form)"
                  class="input-error"
                >
                  {{ getErrors('is_discountable', form) }}
                </p>
              </div>
            </div>
          </PageTabPanel>

          <PageTabPanel>
            <div class="sm:flex sm:justify-between sm:border-b sm:border-gray-400 sm:pb-5 mb-5">
              <div class="border-b border-gray-400 sm:border-b-0 pb-5 sm:pb-0">
                <h3 class="text-lg font-semibold text-blue-600">Inventory</h3>
              </div>
              <div class="input-group pt-5 sm:pt-0">
                <div class="input-group-checkbox items-center py-3">
                  <div class="input-checkbox-container">
                    <input
                      v-model="form.track_inventory"
                      id="track_inventory"
                      name="track_inventory"
                      type="checkbox"
                    />
                  </div>
                  <div class="input-label-container">
                    <label for="has_ecommerce"> Track inventory </label>
                  </div>
                </div>
                <p
                  v-if="getErrors('track_inventory', form)"
                  class="input-error"
                >
                  {{ getErrors('track_inventory', form) }}
                </p>
              </div>
            </div>
            <inventory
              :inventory="inventory"
              @edit="viewPackage"
            />
          </PageTabPanel>

          <PageTabPanel
            without-padding
            locked-height
          >
            <ActivityLog
              :resource-type="LOG_TYPES.PRODUCT"
              :resource-id="product.id"
            />
          </PageTabPanel>
        </PageTabPanels>
      </PageTabGroup>
    </div>

    <template #overlays>
      <OverlaySlideOver
        v-model:value="showingActivityDetails"
        @close="showingActivityDetails = false"
      >
        <template #header>
          <h3 class="text-lg leading-6 font-medium text-gray-900">Batch Information</h3>
          <p class="mt-1 max-w-2xl text-sm text-gray-600">Batch & Inventory Details</p>
          <a
            href="/packages/1"
            class="text-blue-600 group flex items-center text-sm py-2"
          >
            <PencilAltIcon
              class="mr-2 h-5 w-5 text-blue-600"
              aria-hidden="true"
            />
            Edit Batch
          </a>
        </template>

        <div class="bg-gray-100 overflow-hidden">
          <div class="border-t border-gray-400 px-4 py-5 sm:p-0">
            <dl class="sm:divide-y sm:divide-gray-400">
              <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3 flex items-center">
                <dt class="text-sm font-medium text-gray-600">Publish</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  <Switch
                    v-model="enabled"
                    :class="[
                      enabled ? 'bg-blue-600' : 'bg-gray-400',
                      'relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600'
                    ]"
                  >
                    <span class="sr-only">Use setting</span>
                    <span
                      :class="[
                        enabled ? 'translate-x-5' : 'translate-x-0',
                        'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-gray-100 shadow ring-0 transition ease-in-out duration-200'
                      ]"
                    >
                      <span
                        :class="[
                          enabled ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200',
                          'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity'
                        ]"
                        aria-hidden="true"
                      >
                        <svg
                          class="h-3 w-3 text-gray-400"
                          fill="none"
                          viewBox="0 0 12 12"
                        >
                          <path
                            d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      <span
                        :class="[
                          enabled ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100',
                          'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity'
                        ]"
                        aria-hidden="true"
                      >
                        <svg
                          class="h-3 w-3 text-blue-600"
                          fill="currentColor"
                          viewBox="0 0 12 12"
                        >
                          <path
                            d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z"
                          />
                        </svg>
                      </span>
                    </span>
                  </Switch>
                </dd>
              </div>
              <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                <dt class="text-sm font-medium text-gray-600">Batch Name</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">Blue Magoo</dd>
              </div>
              <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                <dt class="text-sm font-medium text-gray-600">Lineage</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">Hybrid</dd>
              </div>
              <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                <dt class="text-sm font-medium text-gray-600">Expiration Date</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">10/29/2022</dd>
              </div>
              <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                <dt class="text-sm font-medium text-gray-600">SKU</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">FG-00001</dd>
              </div>
              <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                <dt class="text-sm font-medium text-gray-600">Batch #</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">CDSYDXS</dd>
              </div>
              <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                <dt class="text-sm font-medium text-gray-600">Lot #</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">LFG-00000071</dd>
              </div>
              <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                <dt class="text-sm font-medium text-gray-600">Tag #</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">00858</dd>
              </div>
              <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                <dt class="text-sm font-medium text-gray-600">Total QTY</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">200g</dd>
              </div>
              <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                <dt class="text-sm font-medium text-gray-600">Available QTY</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">50g</dd>
              </div>
              <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                <dt class="text-sm font-medium text-gray-600">Total THC</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">18%</dd>
              </div>
              <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                <dt class="text-sm font-medium text-gray-600">Total CDB</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">8%</dd>
              </div>
              <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                <dt class="text-sm font-medium text-gray-600">Total Terpenes</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">25%</dd>
              </div>
            </dl>
          </div>
        </div>
      </OverlaySlideOver>
    </template>

    <template #modals>
      <SmallModal
        :is-open="showingAddSupplier"
        @close="showingAddSupplier = false"
      >
        <template #header> Create Supplier </template>

        <div class="mt-4">
          <CreateForm
            :postUrl="route('products.suppliers.store', { product: product.id })"
            @created="supplierCreated"
          />
        </div>
      </SmallModal>

      <SmallModal
        :is-open="showingAddBrand"
        @close="showingAddBrand = false"
      >
        <template #header> Create Brand </template>

        <div class="mt-4">
          <CreateBrandForm
            :postUrl="route('products.brands.store', { product: product.id })"
            @created="brandCreated"
          />
        </div>
      </SmallModal>

      <SmallModal
        :is-open="showingAddStrain"
        @close="showingAddStrain = false"
      >
        <template #header> Create Strain </template>

        <div class="mt-4">
          <CreateStrainForm
            :postUrl="route('products.strains.store', { product: product.id })"
            :lineages="lineages"
            @created="strainCreated"
          />
        </div>
      </SmallModal>

      <SmallModal
        :is-open="showingAddCategory"
        @close="showingAddCategory = false"
      >
        <template #header> New Category </template>

        <div class="mt-4">
          <CreateTagForm
            title="Category"
            type="product_category"
            :post-url="tagRoute"
            @created="categoryCreated"
          />
        </div>
      </SmallModal>

      <SmallModal
        :is-open="showingAddTag"
        @close="showingAddTag = false"
      >
        <template #header> New Tag </template>

        <div class="mt-4">
          <CreateTagForm
            title="Tag"
            type="product_tag"
            :post-url="tagRoute"
            @created="productTagCreated"
          />
        </div>
      </SmallModal>

      <SmallModal
        :is-open="showingDispenseModal"
        @close="showingDispenseModal = false"
      >
        <template #header> Dispense Products </template>

        <div class="mt-4">
          <DispenseForm
            :products="productToDispense"
            @dispensed="dispensed()"
            ref="dispenseForm"
          />
        </div>

        <template #footer>
          <button
            type="button"
            class="btn px-6 py-2 bg-blue-600 text-gray-100 font-bold"
            @click="dispense()"
          >
            Dispense
          </button>
          <button
            type="button"
            class="btn px-6 py-2 bg-gray-100 border border-gray-400 text-blue-600 ml-3 font-semibold"
            @click="showingDispenseModal = false"
          >
            Cancel
          </button>
        </template>
      </SmallModal>

      <SmallModal
        :is-open="showingDuplicateModal"
        @close="showingDuplicateModal = false"
      >
        <template #header> Duplicate Product </template>

        <div class="mt-4">Are you sure you want to duplicate this product?</div>

        <template #footer>
          <button
            type="button"
            class="btn btn-primary"
            @click="duplicate()"
          >
            Duplicate
          </button>
          <button
            type="button"
            class="btn btn-secondary ml-3"
            @click="showingDuplicateModal = false"
          >
            Cancel
          </button>
        </template>
      </SmallModal>
    </template>
  </AdminLayout>
</template>

<script setup>
import { useInitGridState } from '@/Components/DataGrid/Composables/grid-state'
import { useLayoutState } from '@/Layouts/layout-state'
import { PageTabGroup, PageTabList, PageTab, PageTabPanels, PageTabPanel } from '@/Components/PageTabs'
import NovaMenuButton from '@/Components/Buttons/NovaMenuButton.vue'

const pageLayout = useLayoutState()
const { context } = useInitGridState()
</script>

<script>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link, useForm } from '@inertiajs/vue3'
import OverlaySlideOver from '@/Components/SlideOvers/OverlaySlideOver'
import { PanelGroup, FlexPanel, FloatPanel } from '@/Components/Panels'
import { Switch } from '@headlessui/vue'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import MultiSelectInput from '@/Components/Forms/MultiSelectInput'
import BasicButton from '@/Components/Buttons/BasicButton'
import checksErrors from '@/Mixins/checksErrors'
import SuccessFlash from '@/Partials/Alerts/SuccessFlash'
import ErrorFlash from '@/Partials/Alerts/ErrorFlash'
import CreateForm from '@/Partials/Suppliers/CreateForm'
import CreateBrandForm from '@/Partials/Brands/CreateForm'
import CreateStrainForm from '@/Partials/Strains/CreateForm'
import CreateTagForm from '@/Partials/Tags/CreateForm'
import DispenseForm from '@/Partials/Products/DispenseForm'
import {
  ArchiveIcon,
  ArrowCircleRightIcon,
  ChevronDownIcon,
  DuplicateIcon,
  HeartIcon,
  PencilAltIcon,
  TrashIcon,
  UserAddIcon,
  BookOpenIcon,
  CollectionIcon,
  SearchIcon
} from '@heroicons/vue/solid'
import { QrcodeIcon } from '@heroicons/vue/outline'

import MediaManager from '@/Components/Media/MediaManager'
import SmallModal from '@/Components/Modals/SmallModal'
import Inventory from '@/Pages/Products/Form/_inventory'
import MediaUploader from '@/Components/Media/MediaUploader'
import PublishSelector from '@/Components/Menus/PublishSelector'
import hasAuth from '@/Mixins/hasAuth'
import ComboBox from '@/Components/Forms/ComboBox'
import ActivityLog from '@/Components/ActivityLog/ActivityLog.vue'
import { LOG_TYPES } from '@/Components/ActivityLog/log-types'

export default {
  mixins: [hasAuth, checksErrors],

  components: {
    ActivityLog,
    PanelGroup,
    FloatPanel,
    FlexPanel,
    Inventory,
    AdminLayout,
    Head,
    Link,
    OverlaySlideOver,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    CollectionIcon,
    ArchiveIcon,
    ArrowCircleRightIcon,
    ChevronDownIcon,
    DuplicateIcon,
    HeartIcon,
    PencilAltIcon,
    TrashIcon,
    UserAddIcon,
    QrcodeIcon,
    BookOpenIcon,
    SearchIcon,
    MultiSelectInput,
    SuccessFlash,
    CreateForm,
    Switch,
    DispenseForm,
    BasicButton,
    MediaManager,
    SmallModal,
    CreateBrandForm,
    CreateStrainForm,
    CreateTagForm,
    MediaUploader,
    PublishSelector,
    ErrorFlash,
    ComboBox
  },

  props: {
    /**
     * A list of packages that belong to this product. Displayed in Inventory tab
     */
    inventory: {
      type: Array,
      default() {
        return []
      }
    },

    /**
     * A list of media objects. Used by media manager.
     */
    media: {
      type: Array,
      default() {
        return []
      }
    },

    /**
     * The current company model
     */
    company: {
      type: Object,
      required: true
    },

    /**
     * Flash messages from the server
     */
    flash: {
      default: null
    },

    product: Object,
    types: Object,
    regulationTypes: Object,
    categories: Array,
    productTags: Array,
    brands: Array,
    suppliers: Array,
    strains: Array,
    units: Object,
    lineages: Object,
    medicalRoutes: Array,
    medicalDevices: Array,
    showGenerateSkuAction: Boolean,
    showMedicalRouteId: Boolean,
    showMedicalDeviceId: Boolean
  },

  data() {
    return {
      LOG_TYPES,
      form: {
        // name: '',
        // sku: null,
        // type: null,
        // regulation_type: null,
        // brand_id: null,
        // supplier_id: null,
        // strain_id: null,
        // categories: [],
        // product_tags: [],
        // excerpt: null,
        // description: null,
        // is_recreational: false,
        // has_ecommerce: true,
        // is_discountable: true,
        // unit: null,
        // unit_weight: null,
        // price_per_unit: null,
        // quantity_total: null,
        // quantity_available: null,
        // unit_price: null,
        // sale_price: null,
        // pricing_concentration: null,
        // pricing_unit: null,
      },
      enabled: false,
      showingActivityDetails: false,
      showingAddBrand: false,
      showingAddSupplier: false,
      showingAddStrain: false,
      showingAddCategory: false,
      showingAddTag: false,
      showingDispenseModal: false,
      showingDeleteImage: false,
      showingDuplicateModal: false
    }
  },

  created() {
    this.setupForm()

    this.actionForm = useForm({})

    this.mediaForm = useForm({
      media: []
    })
  },

  watch: {
    'form.category_id': function (newVal, oldVal) {
      let foundSubCategory = _.find(this.subCategories, (subCategory) => subCategory.id === this.form.sub_category_id)

      this.form.sub_category_id = foundSubCategory?.id || null
    },
    'form.sub_category_id': function (newVal, oldVal) {
      // Inertia.reload({ only: ['productTags'] });
      this.$inertia.replace(route(route().current(), { product: this.product.id }), {
        method: 'get',
        data: {
          sub_category_id: newVal
        },
        preserveState: true,
        preserveScroll: true,
        only: ['productTags']
      })
    }
  },

  computed: {
    actions() {
      let actions = []

      if (this.product.is_published) {
        actions.push({
          name: 'Un-Publish',
          method: this.unpublish
        })
      } else {
        actions.push({
          name: 'Publish',
          method: this.publish
        })
      }

      actions.push({
        name: 'Dispense',
        method: this.dispense
      })

      if (this.product.deleted_at) {
        actions.push({
          name: 'Restore',
          method: this.restore
        })
      } else {
        actions.push({
          name: 'Archive',
          method: this.archive
        })
      }

      return actions
    },

    subCategories() {
      if (!this.form.category_id) {
        return []
      }

      return (
        _.find(this.categories, (category) => {
          return category.id === this.form.category_id
        })?.children || []
      )
    },

    productTagOptions() {
      return _.map(this.productTags, (tag) => {
        return {
          value: tag,
          label: tag
        }
      })
    },

    productToDispense() {
      return [
        {
          id: this.product.id,
          name: this.product.name,
          quantity_available: this.product.quantity_available
        }
      ]
    },

    /**
     * The url to upload files to
     * @returns String
     */
    uploadRoute() {
      return route('products.media.store', { product: this.product.id })
    },

    /**
     * The url to upload files to
     * @returns String
     */
    tagRoute() {
      return route('products.tags.store', { product: this.product.id })
    },

    /**
     * Returns a function that when executed, will provide a url to delete the file passed as function argument
     * This function gets passed to child class and executed there. A helpful pattern for abstracting
     * "how" something gets done to avoid tying our code to the tightenco/ziggy lib
     * * @returns {(function(*))|*}
     */
    deleteRoute() {
      let theProduct = this.product
      return (file) => {
        return route('products.media.destroy', { product: theProduct.id, media: file.id })
      }
    },

    /**
     * Returns a function that when executed, will provide a url to set a file as the "featured" image.
     * This function gets passed to child class and executed there. A helpful pattern for abstracting
     * "how" something gets done to avoid tying our code to the tightenco/ziggy lib
     * @returns {(function(*))|*}
     */
    featuredRoute() {
      let theProduct = this.product
      return (file) => {
        return route('products.images.featured', { product: theProduct.id, image: file.id })
      }
    },

    /**
     * The url to send a un-publish package request
     * @returns String
     */
    createPackageRoute() {
      return route('packages.new', { product_id: this.product.id })
    },

    /**
     * Configuration variables for laravel vapor
     * @returns {{ enabled: *}}
     */
    vapor() {
      return {
        enabled: this.$page?.props?.util?.enable_vapor_uploads || false
      }
    },

    novaRoute() {
      return route('nova.pages.detail', {
        resource: 'products',
        resourceId: this.product.id
      })
    }
  },

  methods: {
    setupForm() {
      this.form = useForm({
        ...this.product,
        // ..._.pick(this.product, [
        //     'name',
        //     'sku',
        //     'item_number',
        //     'type',
        //     'medical_route_id',
        //     'medical_device_id',
        //     'category_id',
        //     'sub_category_id',
        //     'regulation_type',
        //     'unit',
        //     'unit_weight',
        //     'price_per_unit',
        //     'quantity_total',
        //     'quantity_available',
        //     'categories',
        //     'product_tags',
        //     'excerpt',
        //     'description',
        //     'track_inventory',
        //     'is_recreational',
        //     'has_ecommerce',
        //     'is_discountable',
        //     'unit_price',
        //     'sale_price',
        //     'pricing_concentration',
        //     'pricing_unit',
        // ]),
        ...{
          brand_id: this.product.brand ? this.product.brand.id : null,
          supplier_id: this.product.supplier ? this.product.supplier.id : null,
          strain_id: this.product.strain ? this.product.strain.id : null
        }
      })
    },

    save() {
      this.form.put(route('products.update', { product: this.product.id }), {
        onFinish: () => {}
      })
    },

    showPackageOverlay() {
      this.showingActivityDetails = true
    },

    openAddBrand() {
      this.showingAddBrand = true
    },

    openAddSupplier() {
      this.showingAddSupplier = true
    },

    openAddStrain() {
      this.showingAddStrain = true
    },

    brandCreated() {
      this.showingAddBrand = false
      this.form.brand_id = this.product.brand ? this.product.brand.id : null
    },

    supplierCreated() {
      this.showingAddSupplier = false
      this.form.supplier_id = this.product.supplier ? this.product.supplier.id : null
    },

    strainCreated() {
      this.showingAddStrain = false
      this.form.strain_id = this.product.strain ? this.product.strain.id : null
    },

    categoryCreated() {
      this.showingAddCategory = false
      this.form.categories = this.product.categories
    },
    productTagCreated() {
      this.showingAddTag = false
      this.form.product_tags = this.product.product_tags
    },

    showDispense() {
      this.showingDispenseModal = true
    },

    dispense() {
      this.$refs.dispenseForm.save()
    },

    dispensed() {
      this.showingDispenseModal = false
    },

    archive() {
      this.actionForm.post(route('products.archive', { product: this.product.id }))
    },

    restore() {
      this.actionForm.post(route('products.restore', { product: this.product.id }))
    },

    printLabel() {
      window.open(route('products.qrcode.show', { product: this.product.id }), '_blank')
    },

    showDuplicate() {
      this.showingDuplicateModal = true
    },

    generateSku() {
      this.actionForm.post(route('products.sku.generate', { product: this.product.id }), {
        onFinish: () => {
          this.form.sku = this.product.sku
        }
      })
    },

    duplicate() {
      this.actionForm.post(route('products.duplicate', { product: this.product.id }), {
        onFinish: () => {
          this.showingDuplicateModal = false
        }
      })
    },

    getRouter() {
      return route
    },

    /**
     * Redirects the browser to the package show page
     * @param inventory
     */
    viewPackage(inventory) {
      const url = route('packages.show', { package: inventory.id })
      this.$inertia.visit(url)
    },

    goToCreatePackage() {
      this.$inertia.visit(this.createPackageRoute)
    },

    goToAudit() {
      const url = route('products.balance-entries.index', { product: this.product.id })
      this.$inertia.visit(url)
    }
  }
}
</script>
